import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import { useState, useEffect } from 'react';

var useActiveElement = function useActiveElement(isModalActive) {
  var _useState = useState(document.activeElement),
    _useState2 = _slicedToArray(_useState, 2),
    activeElement = _useState2[0],
    setActiveElement = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    prevIsModalActive = _useState4[0],
    setPrevIsModalActive = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    currentIsModalActive = _useState6[0],
    setCurrentIsModalActive = _useState6[1];
  useEffect(function () {
    if (prevIsModalActive !== currentIsModalActive) {
      setCurrentIsModalActive(isModalActive);
      setPrevIsModalActive(isModalActive);
    }
    if (!isModalActive) {
      setActiveElement(document.activeElement);
    }
  }, [currentIsModalActive, prevIsModalActive]);
  return activeElement;
};

export { useActiveElement as default };
